import { 
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Container,
  Box,
  Heading
} from '@chakra-ui/react'
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { updateUser } from '@Stores/user';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import './Login.css';
import { state } from '@/assets/vender/funcodeDecoder';

function Login() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector(state => state.user.value)
  const [isStartupSubmitted, setIsStartupSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  

  // 取得 Device ID
  async function getDeviceIdByFingerprint() {
    // 檢查 localStorage 中是否已有 device ID
    const storedDid = localStorage.getItem('_fa_did');
    if (storedDid) {
      return storedDid;
    } else {
      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();
      // localStorage.setItem('_fa_did', visitorId);
      state.set('did', visitorId);
      return visitorId;
    }
  }

  // 用啟動碼取得 JWT
  async function getJwt(account) {
    const jwt = localStorage.getItem('_fa_jwt');
    if (jwt) {
      return { success: true, token: jwt, message: '' };
    } else {
      const deviceId = await getDeviceIdByFingerprint();
      const baseurii = 'https://funaccount.azurewebsites.net';
      
      try {
        const response = await fetch(`${baseurii}/api/v2/shinfox/Login`, {
          method: 'POST',
          body: JSON.stringify({ account, deviceid: deviceId }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8'
          }
        });
        
        try {
          // 不管 response.ok 是否為 true，都嘗試解析 JSON
          const json = await response.json();
          // console.log('API 回應:', json); // 記錄完整的 API 回應
          
          if (json.returnCode === 0) {
            state.set("btc", btoa(account));
            state.set('jwt', json.access_token);
            // localStorage.setItem('_fa_btc', btoa(account));
            // localStorage.setItem('_fa_jwt', json.access_token);
            return { success: true, token: json.access_token, message: '' };
          } else {
            // 非成功的回應碼
            localStorage.removeItem('_fa_btc');
            localStorage.removeItem('_fa_jwt');
            console.error(`錯誤 (${json.returnCode}): ${json.msg}`);
            return { success: false, token: '', message: json.msg || '啟動碼驗證失敗' };
          }
        } catch (jsonError) {
          // JSON 解析錯誤
          console.error('解析 API 回應時出錯:', jsonError);
          return { success: false, token: '', message: '處理伺服器回應時出錯' };
        }
      } catch (err) {
        localStorage.removeItem('_fa_btc');
        localStorage.removeItem('_fa_jwt');
        console.error(err);
        return { success: false, token: '', message: `登入失敗: ${err.message}` };
      }
    }
  }
  
  
  // 啟動碼表單
  const {
    handleSubmit: handleSubmitStartup,
    register: registerStartup,
    formState: { errors: startupErrors },
  } = useForm({
    defaultValues: {
      ...user,
    }
  })

  // 使用者名稱表單
  const {
    handleSubmit: handleSubmitUsername,
    register: registerUsername,
    formState: { errors: usernameErrors },
  } = useForm({
    defaultValues: {
      ...user,
    }
  })

  // 提交啟動碼
  const onSubmitStartup = async (data) => {
    if (!data) return;
    
    setIsLoading(true);
    setLoginError('');
    
    try {
      // 使用啟動碼獲取 JWT
      const result = await getJwt(data.startupcode);
      
      if (result.success) {
        // 保存啟動碼到 Redux 和本地狀態
        dispatch(updateUser({ startupcode: data.startupcode }));
        
        // 切換到使用者名稱輸入畫面
        setIsStartupSubmitted(true);
      } else {
        // 顯示來自 API 的錯誤訊息
        setLoginError(result.message || '啟動碼驗證失敗，請檢查後重試');
      }
    } catch (error) {
      console.error('登入處理錯誤:', error);
      setLoginError('登入處理發生錯誤: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  }

  // 提交使用者名稱
  const onSubmitUsername = (data) => {
    if (!data) return;
    dispatch(updateUser({ username: data.username }));
    navigate('/home');
  }

  // 返回啟動碼頁面
  const handleBack = () => {
    setIsStartupSubmitted(false);
  }

  useEffect(() => {
    // dispatch(resetUserAll());
    
    // 檢查是否有保存的啟動碼和使用者名稱
    const savedJwt = localStorage.getItem('_fa_jwt');
    const savedUsername = user?.username;
    if (savedJwt && savedUsername) {
      navigate('/home');
    }
  }, []);
  

  return (
    <div className="App">
      <Container>
        {!isStartupSubmitted ? (
          // 啟動碼登入畫面
          <Box>
            <form onSubmit={handleSubmitStartup(onSubmitStartup)}>
              <FormControl isInvalid={!!startupErrors.startupcode || !!loginError}>
                <FormLabel fontWeight='bold'>啟動碼登入</FormLabel>
                <Input
                   type='text' 
                   borderColor='#757474'
                   {...registerStartup('startupcode', {
                    required: '請輸入啟動碼'
                   })} 
                />
                <FormErrorMessage>
                  {startupErrors.startupcode?.message || loginError}
                </FormErrorMessage>
              </FormControl>
              <Button 
                width='100%'
                mt='1rem'
                colorScheme='blue' 
                type='submit'
                isLoading={isLoading}
                loadingText="驗證中..."
              >
                啟動碼登入
              </Button>
            </form>
          </Box>
        ) : (
          // 使用者名稱畫面
          <Box>
            <Heading size="md" mb="4">啟動碼: {user.startupcode}</Heading>
            <form onSubmit={handleSubmitUsername(onSubmitUsername)}>
              <FormControl isInvalid={usernameErrors.username}>
                <FormLabel fontWeight='bold'>使用者名稱</FormLabel>
                <Input
                   type='text' 
                   borderColor='#757474'
                   {...registerUsername('username', {
                    required: '請輸入使用者名稱'
                   })} 
                />
                 <FormErrorMessage>
                  {usernameErrors.username && usernameErrors.username.message}
                </FormErrorMessage>
              </FormControl>
              <Button 
                width='100%'
                mt='1rem'
                colorScheme='green' 
                type='submit'
              >
                開始掃描
              </Button>
              <Button
                width='100%'
                mt='0.5rem'
                variant="outline"
                onClick={handleBack}
              >
                返回
              </Button>
            </form>
          </Box>
        )}
      </Container>
    </div>
  );
}

export default Login;
